import Hero from '@/components/cms/Hero';

import DynamicComponent from './DynamicComponent';

const HeroWrapper = ({ blok }) => {
  const {
    title,
    subtitle,
    footer,
    footerMargin,
    topBorder,
    bottomBorder,
    topGradient,
    bottomGradient,
    backgroundDesktop,
    backgroundTablet,
    backgroundMobile,
    backgroundColor,
    backgroundColorPreset,
    sizeImage,
    images,
    html,
    css,
    variant,
    eager
  } = blok;

  return (
    <Hero
      title={title[0] && <DynamicComponent blok={title[0]} />}
      subtitle={subtitle[0] && <DynamicComponent blok={subtitle[0]} />}
      footer={
        footer &&
        footer.length > 0 && (
          <>
            {footer.map((blok) => (
              <DynamicComponent blok={blok} key={blok._uid} />
            ))}
          </>
        )
      }
      footerMargin={footerMargin}
      backgroundDesktop={backgroundDesktop}
      backgroundTablet={backgroundTablet}
      backgroundMobile={backgroundMobile}
      backgroundColor={backgroundColor}
      backgroundColorPreset={backgroundColorPreset}
      topBorder={topBorder}
      bottomBorder={bottomBorder}
      topGradient={topGradient}
      bottomGradient={bottomGradient}
      html={html}
      css={css}
      sizeImage={sizeImage}
      variant={variant}
      eager={eager}
      images={images}
    ></Hero>
  );
};

export default HeroWrapper;
